module.exports = __webpack_public_path__ + "img/6.6be4e9c2.png";